import PropTypes from 'prop-types';
import React from 'react';
import classNames from 'classnames';
import './styles.scss';
import Icon from '../Icon/Icon';

const Skill = ({
  children,
  id,
  className,
  skillLevel,
  categoryClasses,
  validated,
  isPointer,
  onClick,
  onHover,
  fixed,
  ...other
}) => {
  const addClassChildren = React.Children.map(children, child => {
    const { ref } = child;

    return React.cloneElement(child, {
      className: classNames((child && child.props && child.props.className) || '', {
        'skill-label-small': ref === 'label',
        'lvl-decrement': ref === 'decrement',
        'lvl-increment': ref === 'increment',
      }),
    });
  });

  const skillClasses = classNames(className, 'skill-wrapper', {
    onHover: onHover,
    fixed: fixed,
    'has-validated': validated,
    'cursor-pointer': isPointer,
  });
  const skillLevelClasses = classNames(categoryClasses, {
    validated: validated,
    'skill-level': true,
    'no-skill-level': skillLevel === 0,
    'skill-level-beginner': skillLevel === 1,
    'skill-level-intermediate': skillLevel === 2,
    'skill-level-professional': skillLevel === 3,
  });

  const addIcon = skillLevel === 0 ? <Icon className="add-skill-icon" name="icon--add" /> : '';

  return (
    <div id={id} className={skillClasses} onClick={onClick}>
      <div className="overlay" />
      <div className="skill-level-wrapper">
        <div className="skill-level-background" />
        <div className={skillLevelClasses} />
        {addIcon}
      </div>
      <div className="skill-label">{addClassChildren}</div>
    </div>
  );
};

Skill.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  categoryClasses: PropTypes.string,
  validated: PropTypes.bool,
  skillLevel: PropTypes.number.isRequired,
  onClick: PropTypes.func,
};

Skill.defaultProps = {};

export default Skill;
